import { useState } from "react";
import "./style.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  fetchPatientDetailsUuid,
  coupleIdChecker,
  postAppointment,
} from "../../Redux/Thunk/Actions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../../assets/images/ascas.svg";
import Headers from "../../Components/Header/Headers";
import { PrescriptionFooter } from "../../Components/Prescription Footer/PrescriptionFooter";

export default function DeliveryEssentialsTemplate(props) {
  const [valueChange, setvalueChange] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [patientOne_UUId, setPatientOne_UUId] = useState("");
  const patientId = useSelector((state) => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
    });

  const handleChange = (e) => {
    // const { name, value } = e.target;
    // setvalueChange({ ...valueChange, [name]: value });
    var text = e.target.value;

    if (e.target.name === "patientId1") {
      if (/^(ASCAS|VDASCAS)\d+$/i.test((e.target.value || "").trim())) {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value,
          };
          props.loaderchange("true");
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat =
              data?.titles + " " + data?.first_name + " " + data?.last_name;
            if (e.target.name === "patientId1") {
              setPatientOne_UUId(data?.id);
              setvalueChange({
                ...valueChange,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text,
              });
            }
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === "patientId1") {
          setvalueChange({
            ...valueChange,
            patientId1: e.target.value,
          });
        }
      }
    } else {
      console.log("Going in");
      setvalueChange({ ...valueChange, [e.target.name]: e.target.value });
      if (e.target.name === "nextappointment") {
        const dateTime = e.target.value.split("T");
        setAppointmentData({
        ...appointmentData,
        date: dateTime[0],
        time: dateTime[1],
        p_uhid: props.patientsData.p_uhid,
        name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
        status: "Not Visited",
        notes: "Booking Visit",
        patient_id: patientId,
        });
        }
    }
  };

  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value, options = {}) => {
    const { style = { border: "1px solid black", textAlign: "center" } } =
      options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const {
      style = { border: "1px solid black", textAlign: "center" },
      colspans = 1,
    } = options;
    return (
      <th colSpan={colspans} style={style}>
        {value}
      </th>
    );
  };

  const handlesubmit = () => {
    props.loaderchange("true");
    try {
      if (
        props.patientsData.id !== "" &&
        props.patientsData.p_uhid !== "" &&
        /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())
      ) {
        setshow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById(
            "prescriptionReportWrap"
          ).innerHTML;

          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
            };
            createNewAppointment();
          // Prepare payload for creating report
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: "",
              template_type: "DeliveryEssentials",
            },
          };

          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate("/PatientView");
            Swal.fire({
              title: "Successful.",
              text: "Record added successful.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
    // props.loaderchange("false")
  };
  return (
    <>
      <div id="reportcreate">
        <div className="outer1">
          <div
            className=""
            style={{ width: "100%", display: "block" }}
            id="patientInfo1"
          >
            <div style={{ width: "100%" }}>
              <img
                className="header_image"
                // src={"https://s3.amazonaws.com/likodi.com/ascslogo.png"}
                src={headerimage}
                style={{
                  // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                  width: "100%",
                  margin: "0 auto",
                }}
              ></img>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                gap: "3px",
                backgroundColor: "#f7f7f7 ",
                borderRadius: "6px",
                padding: "16px 8px 16px 8px",
                gap: "3px",
              }}
            >
              <div
                style={{ display: "flex", gap: "16px", alignItems: "center" }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "125px 16px 250px",
                    alignItems: "center ",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Patient ID</span>
                  <span style={{ fontWeight: 600 }}>: </span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    value={props.patientsData.p_uhid}
                    onChange={(e) => handleChange(e)}
                    name="patientId"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{props.patientsData.p_uhid}
                  </span>
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient Name</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                  name="patientName"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    color: "#000",
                  }}
                />
                <span
                  className={`input ${!show ? "hide" : "show"}`}
                  style={{ width: "100%" }}
                >
                  &nbsp;
                  {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "125px 16px 250px",
                    alignItems: "center ",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Gender</span>
                  <span style={{ fontWeight: 600 }}>: </span>
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    value={valueChange.gender1}
                    name="gender"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      backgroundColor: "white",
                    }}
                  >
                    <option value={props.patientsData.gender} selected>
                      {props.patientsData.gender}
                    </option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Others">Others</option>
                    <option value="Decline to State">Decline to State</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{props.patientsData.gender}
                  </span>
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Age</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={props.patientsData.age}
                  name="age1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.age}
                </span>
              </div>
            </div>

            {/* <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            gap: "3px",
            backgroundColor: "#f7f7f7 ",
            borderRadius: "6px",
            padding: "16px 8px 16px 8px",
            gap:"3px"

          }}
        > */}
            {/* Patient ID and Couple ID (Side by side) */}
            {/* <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient ID</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                value={valueChange.patientId1}
                onChange={(e) => handleChange(e)}
                name="patientId1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{valueChange.patientId1}
              </span>
            </div>
          </div> */}

            {/* Patient Name */}
            {/* <div
            style={{
              display: "grid",
              gridTemplateColumns: "125px 16px 250px",
              alignItems: "center ",
            }}
          >
            <span style={{ fontWeight: 600 }}>Patient Name</span>
            <span style={{ fontWeight: 600 }}>: </span>
            <input
              type="text"
              className={`createTime ${show ? "hide" : "show"}`}
              onChange={(e) => handleChange(e)}
              value={valueChange.patientName1}
              name="patientName1"
              style={{
                border: "1px solid #ddd",
                outline: "none",
                padding: "10px",
                color: "#000",
              }}
            />
            <span
              className={`input ${!show ? "hide" : "show"}`}
              style={{ width: "100%" }}
            >
              &nbsp;{valueChange.patientName1}
            </span>
          </div> */}
            {/* Gender and Blood Group (Side by side) */}
            {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Gender</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <select
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={valueChange.gender1}
                name="gender1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  backgroundColor: "white",
                }}
              >
                <option value="" disabled selected>
                  Select Gender
                </option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Others">Others</option>
                <option value="Decline to State">Decline to State</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{valueChange.gender1}
              </span>
            </div>
          </div> */}

            {/* <div
            style={{
              display: "grid",
              gridTemplateColumns: "125px 16px 250px",
              alignItems: "center ",
            }}
          >
            <span style={{ fontWeight: 600 }}>Age</span>
            <span style={{ fontWeight: 600 }}>: </span>
            <input
              type="text"
              className={`createTime ${show ? "hide" : "show"}`}
              onChange={(e) => handleChange(e)}
              value={valueChange.age1}
              name="age1"
              style={{
                border: "1px solid #ddd",
                outline: "none",
                padding: "10px",
              }}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.age1}
            </span>
          </div> */}

            {/* <div
            style={{
              display: "grid",
              gridTemplateColumns: "125px 16px 250px",
              alignItems: "center",
              // paddingLeft: "25px",
            }}
          >
            <span style={{ fontWeight: 600 }}>Blood Group</span>
            <span style={{ fontWeight: 600 }}>: </span>
            <select
              className={`createTime ${show ? "hide" : "show"}`}
              onChange={(e) => handleChange(e)}
              name="bloodGroup1"
              value={valueChange.bloodGroup1}
              style={{
                border: "1px solid #ddd",
                outline: "none",
                padding: "10px",
                backgroundColor: "white",
              }}
            >
              <option value="" disabled selected>
                Select Blood Group
              </option>
              <option value="A+">A+</option>
              <option value="A-">A-</option>
              <option value="B+">B+</option>
              <option value="B-">B-</option>
              <option value="AB+">AB+</option>
              <option value="AB-">AB-</option>
              <option value="O+">O+</option>
              <option value="O-">O-</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.bloodGroup1}
            </span>
          </div> */}
            {/* </div> */}
          </div>
          <h1> THINGS TO BRING DURING DELIVERY</h1>
          <table className="table_1" border="1px" cellSpacing="0px">
            <tbody>
              <tr>
                <th colSpan={2}> For mother</th>
              </tr>
              <tr>
                <td> Feeding gown/ nighty 4 -6 numbers</td>
                <td>
                  {" "}
                  Vertical zips offer comfort; Horizontal zips are not very
                  comfortable
                  <br />
                  <br />
                  Get one size bigger
                </td>
              </tr>
              <tr>
                <td> Maternity Bra 6-8</td>
                <td>
                  Get one size bigger remembering that breasts will get engorged
                  after delivery
                </td>
              </tr>
              <tr>
                <td> Maternity panties 6-8</td>
                <td>
                  {" "}
                  Measure waist size around belly button after delivery ;Get
                  cotton panties
                </td>
              </tr>
              <tr>
                <td> Maternity Pads</td>
                <td>
                  {" "}
                  Abena , NUMOM Brand Buy Maternity pads as the bleeding after
                  delivery will be heavy especially after vaginal delivery
                </td>
              </tr>
              <tr>
                <td> Soap, Shampoo ,Brush , Paste </td>
                <td> Can take bath after delivery irrespective of mode</td>
              </tr>
              <tr>
                <td> Water bottles , tea cups , spoons</td>
                <td> It’s essential to drink 3-4 litres of water everyday</td>
              </tr>
              <tr>
                <td> Comb, Bindi, kajal</td>
                <td> It’s good to look nice</td>
              </tr>
              <tr>
                <td> Charger</td>
                <td>
                  <input
                    className={`input ${show ? "hide" : "show"}`}
                    name="charger"
                    onChange={handleChange}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.charger}
                  </span>
                </td>
              </tr>
              <tr>
                <td> Bathroom slippers</td>
                <td>
                  <input
                    className={`input ${show ? "hide" : "show"}`}
                    name="bathroomslippers"
                    onChange={handleChange}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.bathroomslippers}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <br />
          <table className="table_1" border="1px" cellSpacing="0px">
            <tbody>
              <tr>
                <th colSpan={2}> For baby</th>
              </tr>
              <tr>
                <td> Feeding pillow</td>
                <td> U shaped ones .</td>
              </tr>
              <tr>
                <td> Cloth Nappies/Diapers</td>
                <td>
                  {" "}
                  Newborn size ; You can use the one with straps rather than
                  pants
                </td>
              </tr>
              <tr>
                <td> Wrapping towel 6-8</td>
                <td>
                  {" "}
                  Learn wrapping from the nurses; Cloth towel / Veshti is ideal
                  to wrap the baby in India. Thick woolen material will be
                  needed in winters / cold temperatures
                </td>
              </tr>
              <tr>
                <td> Cotton Jablas</td>
                <td> With buttons/ strings in front</td>
              </tr>
              <tr>
                <td> Baby bed</td>
                <td> Helps you carry the newborn especially for check ups</td>
              </tr>
              <tr>
                <td> Wet tissues, diaper rash cream</td>
                <td>
                  {" "}
                  Can be useful in hospital setting as washing the clothes may
                  not be an option
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <br />
          {/* <p style={{textAlign:"center",padding:"30px 10px"}}>x x x End Of Bill x x x</p> */}
        </div>
      </div>
      <p style={{fontWeight:"600"}}>
NEXT APPOINTMENT -{" "}
<input
name="nextappointment"
onChange={handleChange}
type="datetime-local"
// type="date"
/>
</p>
      <div className="Footer">
        <button onClick={handlesubmit} className="Button_Create">
          Add Report
        </button>
      </div>
      <div id="prescriptionReport">
        <div id="prescriptionReportWrap">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          <div>
            <h1 style={{ textAlign: "center" }}>
              THINGS TO BRING DURING DELIVERY
            </h1>
          </div>
          <div>
            <table style={{ width: "100%", marginBottom: "10px" }}>
              <tbody>
                <tr>{renderTableTH("FOR MOTHER", { colspans: 2 })}</tr>
                {[...Array(9)].map((_, i) => {
                  const Th = [
                    "Feeding gown/ nighty 4 -6 numbers",
                    "Maternity Bra 6-8",
                    "Maternity panties 6-8",
                    "Maternity Pads",
                    "Soap, Shampoo ,Brush , Paste",
                    "Water bottles , tea cups , spoons",
                    "Comb, Bindi, kajal",
                    "Charger",
                    "Bathroom slippers",
                  ];
                  const Td = [
                    "Vertical zips offer comfort; Horizontal zips are not very comfortable Get one size bigger",
                    "Get one size bigger remembering that breasts will get engorged after delivery",
                    "Measure waist size around belly button after delivery ;Get cotton panties",
                    "Abena , NUMOM Brand Buy Maternity pads as the bleeding after delivery will be heavy especially after vaginal delivery",
                    "Can take bath after delivery irrespective of mode",
                    "It’s essential to drink 3-4 litres of water everyday",
                    "It’s good to look nice",
                    valueChange.charger,
                    valueChange.bathroomslippers,
                  ];
                  return (
                    <tr key={i}>
                      {renderTableTH(Th[i])}
                      {renderTableTD(Td[i])}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div>
            <table style={{ width: "100%", marginBottom: "10px" }}>
              <tbody>
                <tr>{renderTableTH("FOR  BABY", { colspans: 2 })}</tr>
                {[...Array(6)].map((_, i) => {
                  const Th = [
                    "Feeding pillow",
                    "Cloth Nappies/Diapers",
                    "Wrapping towel 6-8",
                    "Cotton Jablas",
                    "Baby bed",
                    "Wet tissues, diaper rash cream",
                  ];
                  const Td = [
                    "U shaped ones.",
                    "Newborn size ; You can use the one with straps rather than pants",

                    "Learn wrapping from the nurses; Cloth towel / Veshti is ideal to wrap the baby in India. Thick woolen material will be needed in winters / cold temperatures",
                    "With buttons/ strings in front",
                    "Helps you carry the newborn especially for check ups",
                    "Can be useful in hospital setting as washing the clothes may not be an option",
                  ];
                  return (
                    <tr key={i}>
                      {renderTableTH(Th[i])}
                      {renderTableTD(Td[i])}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {/* <div>
            {[
              "Feeding pillow",
              "Cloth Nappies/Diapers",
              "Wrapping towel 6-8",
              "Cotton Jablas",
              "Baby bed",
              "Wet tissues, diaper rash cream",
            ].map((ele, ind) => {
              return (
                <h6>
                  {ind + 1}) {ele}
                </h6>
              );
            })}
          </div> */}
          <div style={{ marginTop: "10px" }}>
{renderReportfield("Next Appointment : ",appointmentData.date?.split("-").reverse().join("-"))}
</div>


<p class="Dani"></p>
<PrescriptionFooter/>
        </div>
      </div>
    </>
  );
}
